import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAccessLogs from '../reducer/access-logs.reducer';

export const selectAccessLogsFeature = createFeatureSelector<fromAccessLogs.AccessLogsState>(
  fromAccessLogs.accessLogsFeatureKey
);

const { selectAll } = fromAccessLogs.accessLogsAdapter.getSelectors();

export const selectAccessLogs = createSelector(selectAccessLogsFeature, selectAll);

export const selectError = createSelector(selectAccessLogsFeature, state => state.baseState.error);

export const selectIsLoading = createSelector(selectAccessLogsFeature, state => state.baseState.isLoading);

export const selectPageNumber = createSelector(selectAccessLogsFeature, state => state.baseState.pageNumber);

export const selectPageSize = createSelector(selectAccessLogsFeature, state => state.baseState.pageSize);

export const selectIsAtEndOfData = createSelector(selectAccessLogsFeature, state => state.baseState.isAtEndOfData);

export const selectTotalRecordCount = createSelector(
  selectAccessLogsFeature,
  state => state.baseState.totalRecordCount
);

export const selectFilters = createSelector(selectAccessLogsFeature, state => state.filters);

export const selectActors = createSelector(selectAccessLogsFeature, state => state.actors);

export const selectAreActorsResolved = createSelector(selectAccessLogsFeature, state => state.areActorsResolved);

export const selectActorsError = createSelector(selectAccessLogsFeature, state => state.actorsError);

/**
 * Portal user ids the API flagged as the patient themselves. Used to render an entry's actor as
 * "You" — see `getActorLine()` for why this is preferred over reading the row's relationship ids.
 */
export const selectSelfActorIds = createSelector(
  selectActors,
  actors => new Set(actors.filter(actor => actor.isSelf).map(actor => actor.patientPortalUserId))
);
